module.exports = __webpack_public_path__ + "media/stylesheets/images/main/openWaiting/openWaiting_mobile_sung-a3f78f5cbd446901f13b1deba722132b.png";